import React from 'react';
import { isEqual } from 'lodash';

import WorkerInformationDetailsCard from './WorkerInformationDetailsCard';
import HomeAddressDetailsCard from './HomeAddressDetailsCard';
import {
  HistoryResponseModel,
  WorkerHistoryDetailsModel,
} from 'api/adminApiClient';
import W9FormDetailsCard from './W9FormDetailsCard';
import WorkerTypeDetailsCard from './WorkerTypeDetailsCard';

type Props = {
  workerId: string;
  historyItem: HistoryResponseModel;
};

export default function WorkerDetailsCard(props: Props) {
  const { historyItem, workerId } = props;
  const historyDetails = historyItem.details as WorkerHistoryDetailsModel;
  const historyId = historyItem.id || '';

  const hasWorkerLocationChanged = !isEqual(
    historyDetails.oldData?.location,
    historyDetails.newData?.location,
  );
  const hasW9FormChanged = !isEqual(
    historyDetails.oldData?.workerFileKey,
    historyDetails.newData?.workerFileKey,
  );

  return (
    <>
      <WorkerInformationDetailsCard
        historyDetails={historyDetails}
        historyId={historyId}
      />
      <WorkerTypeDetailsCard
        historyDetails={historyDetails}
        historyId={historyId}
      />
      {hasWorkerLocationChanged && (
        <HomeAddressDetailsCard
          historyDetails={historyDetails}
          historyId={historyId}
        />
      )}
      {hasW9FormChanged && (
        <W9FormDetailsCard
          historyDetails={historyDetails}
          historyId={historyId}
          workerId={workerId}
        />
      )}
    </>
  );
}
